export const shehuiArticles = [
  {
    id: "shehui-1",
    title: "某沿海城市连夜排查老旧小区电梯隐患，多位居民反映早有征兆",
    summary:
      "一场持续的异响投诉终于引发集中排查。记者走访多个小区，梳理出维保记录与投诉登记之间的时间差。",
    categoryId: "shehui",
    categoryName: "社会热点",
    publishedAt: "2026-10-12 09:20",
    source: "本地资讯观察站",
    tags: ["城市治理", "电梯安全", "民生"],
    heat: 9820,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stylized%20residential%20towers%20at%20night%20with%20elevator%20warning%20light%20in%20deep%20slate%20blue%20and%20orange%20tones%2C%20minimal%20geometric%20illustration%2C%20moody%20editorial%20style%2C%20soft%20gradient%20background&width=1200&height=800&seq=focus-shehui-01&orientation=landscape",
    content: [
      "连日来，某沿海城市多个老旧小区陆续张贴出电梯停运检修的通知。事情的起因，是几位居民在社交平台上集中反映同一栋楼电梯长期存在异响与顿挫感，相关视频短时间内被大量转发。",
      "## 投诉与维保记录的时间差",
      "记者梳理小区物业公开的维保台账发现，最近一次完整保养记录停留在三个月前，而居民最早的投诉登记发生在五个月前。两者之间存在明显的时间空档，这也是居民质疑最集中的地方。",
      "有从事特种设备检测的业内人士表示，老旧电梯的核心部件更换周期通常在五年左右，若无系统性评估，仅靠日常润滑难以彻底消除隐患。",
      "## 排查之后还需长效机制",
      "截至发稿，相关部门已公布集中排查安排，并承诺对存在重大隐患的电梯采取停运整改。多位居民希望，此次排查不止是一次性行动，而是能建立起投诉响应与维保检查联动的长效机制。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "shehui-2",
    title: "暴雨内涝后重建资金去向追踪：三笔款项为何迟迟未到账",
    summary:
      "区级财政公示与实际到账之间存在数月差距。我们对照公开账目，尝试还原资金流转的完整链条。",
    categoryId: "shehui",
    categoryName: "社会热点",
    publishedAt: "2026-10-11 16:45",
    source: "公开账目小组",
    tags: ["灾后重建", "资金监管", "公开透明"],
    heat: 8650,
    content: [
      "去年汛期后，某城区启动了较大规模的内涝修复工程。按照公示方案，三笔专项资金应于本年度上半年分批拨付到位，但部分施工方反映，实际到账时间明显滞后。",
      "## 公示与到账之间的落差",
      "记者比对了财政公开平台上的拨付公告与多家施工单位的收款凭证，发现其中两笔款项的实际到账时间比公告晚了近四个月，另一笔则至今仅有部分到账。",
      "一位不愿具名的项目负责人表示，资金环节的延迟直接影响材料采购与工人工资发放，也让工期一再顺延。",
      "## 流程复杂还是环节堵点",
      "有基层工作人员解释，专项资金往往需经过申报、审核、验收、决算等多个环节，任何一环材料不全都会造成停滞。但多位受访者认为，流程透明度的不足才是公众疑虑的根源。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "shehui-3",
    title: "高校毕业生就业数据背后的统计口径争议，专家呼吁信息公开",
    summary: "同一届毕业生，为何不同口径下的就业率差异明显？我们请多方拆解了统计方法的差异。",
    categoryId: "shehui",
    categoryName: "社会热点",
    publishedAt: "2026-10-10 11:05",
    source: "教育观察线",
    tags: ["就业", "数据统计", "高校"],
    heat: 7210,
    content: [
      "每到毕业季，高校公布的就业率总会引发讨论。今年，多位应届生在社交平台分享了自己的求职经历，并质疑部分统计数据与实际感受不符。",
      "## 不同口径为何差距明显",
      "调查显示，不同统计口径对“就业”的界定并不一致，有的将升学、灵活就业、拟签约都计入分母，有的则仅统计正式劳动合同。口径差异直接导致同一群体出现多个不同数值。",
      "教育研究者指出，统计方法本身没有对错，关键在于是否同步说明口径，让公众能够正确理解数据含义。",
      "## 透明度才是信任的基础",
      "多位专家建议，高校在公布就业情况时应附上统计口径说明与分项数据，同时接受社会监督。信息的完整与透明，比单一数字的高与低更重要。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "shehui-4",
    title: "社区团购退潮后：那些充值未退的会员费究竟去了哪里",
    summary: "平台关停后，用户账户里的余额成了悬案。我们梳理了维权群里的数百条退款诉求。",
    categoryId: "shehui",
    categoryName: "社会热点",
    publishedAt: "2026-10-09 14:30",
    source: "消费维权台",
    tags: ["消费维权", "预付资金", "退款"],
    heat: 6890,
    content: [
      "近两年，多家社区团购平台相继收缩业务。平台退出市场后，用户账户中尚未消费的充值余额如何退还，成为大量消费者共同的困扰。",
      "## 余额为何难以退回",
      "在一个近千人的维权群中，记者看到许多用户晒出的截图：账户余额从几十元到上千元不等。多数人表示，客服热线已无法接通，退款入口也已关闭。",
      "法律人士指出，预付性质的充值余额在平台清算中属于普通债权，清偿顺序靠后，这也是用户难以优先拿回资金的原因之一。",
      "## 预付式消费的监管空白",
      "多位受访者呼吁，针对平台型预付资金应建立更严格的存管制度，避免消费者在平台退出时承担全部风险。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "shehui-5",
    title: "农村寄宿制学校宿舍改造调查：一份被搁置三年的整改方案",
    summary: "一份标注“限期整改”的文件，为何在三年后仍未落地？我们沿着文件编号找到了它的轨迹。",
    categoryId: "shehui",
    categoryName: "社会热点",
    publishedAt: "2026-10-08 08:55",
    source: "基层记录者",
    tags: ["教育设施", "乡村", "监督"],
    heat: 5430,
    content: [
      "在某县的一份公开文件中，记者找到了一份三年前的宿舍安全整改方案，方案明确要求对辖区内寄宿制学校的宿舍电路、消防通道进行改造，并标注了完成期限。",
      "## 文件落地为何缓慢",
      "走访发现，部分学校的改造确实已经完成，但仍有学校维持原状。校方解释称，改造资金需逐年申请，年度预算有限。",
      "一位长期关注乡村教育的志愿者表示，这类问题往往不是“没人管”，而是“资源有限、优先级靠后”，需要更公开的进度披露来推动落实。",
      "## 让整改可见、可查",
      "受访者建议，将整改方案与完成进度一并公开，接受家长与社会监督，让“限期”真正具有约束力。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "shehui-6",
    title: "宠物伤人事件频发，多地拟推行养犬信用记分制度",
    summary: "从登记到记分，多地尝试用更细的规则约束养犬行为。这些新规能否真正落地？",
    categoryId: "shehui",
    categoryName: "社会热点",
    publishedAt: "2026-10-07 19:10",
    source: "城市生活报",
    tags: ["养犬管理", "公共安全", "新规"],
    heat: 5120,
    content: [
      "近期，多起犬只伤人事件引发广泛关注。为回应公众关切，一些城市开始探索以信用记分的方式管理养犬行为。",
      "## 记分制度如何运作",
      "按照拟定的规则，养犬人需完成登记并接种疫苗，出现遛狗不牵绳、未清理粪便等行为将被记分，累计到一定分值将面临限制饲养等处理。",
      "有社区工作者认为，规则的难点不在制定，而在执行与取证。若缺乏日常巡查与技术手段，记分制度容易流于形式。",
      "## 关键在执行",
      "多位受访居民表示，比起制度本身，他们更关心是否真正落实。只有把规则落到实处，才能重建人与宠物和谐共处的公共空间。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
];